import React from "react"
import Spinner from "react-spinkit"
import styled from "styled-components"

export const Indicator = ({ className, children }) =>
  <div className={className}>
    <Spinner name="double-bounce" color="#5E8F45" />
    {children}
  </div>

export const CenteredIndicator = styled(Indicator)`
  margin: auto auto;
`

export const FieldIndicator = styled(Indicator)`
    margin-left: 1rem;
`



// WEBPACK FOOTER //
// ./src/UI/Indicators/index.js